// /bots/tools: каталога нет (владелец 2026-08-14), адрес уводит на первую вкладку «Лабораторий». Раньше — на зашитые
// «Обложки»; теперь — на первую видимую вкладку по порядку из «Меню сайта» (владелец 15.10: вкладки перетаскиваются).
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { NAV_LAYOUT_DEFAULTS, NAV_PATHS, navMode, navVisibleInMenu } from '../api/nav'
import { useNavModes } from '../hooks/useNavModes'
import { isStaff } from '../utils/roles'
import { buildNavTree } from '../utils/navTree'

const FALLBACK = '/bots/tools/covers'

export default function ToolsIndexRedirect() {
	const { modes, layout, loaded } = useNavModes()
	const { user } = useAuth()
	if (!loaded) return null
	const tree = buildNavTree(NAV_PATHS, layout, NAV_LAYOUT_DEFAULTS)
	const group = tree.find((n) => n.item.id === 'tools')
	const first = group?.children.find((c) => navVisibleInMenu(navMode(modes, c.id), isStaff(user?.role)))
	return <Navigate to={first?.path ?? FALLBACK} replace />
}
